let activePopupLocks = 0;
let savedBodyState = null;

function getScrollbarWidth() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 0;
  }

  const viewportWidth = Number(window.innerWidth) || 0;
  const clientWidth = Number(document.documentElement?.clientWidth) || 0;
  const scrollbarWidth = viewportWidth - clientWidth;
  return scrollbarWidth > 0 ? scrollbarWidth : 0;
}

export function lockPopupScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const body = document.body;
  if (!body) {
    return;
  }

  activePopupLocks += 1;
  if (activePopupLocks > 1) {
    return;
  }

  const scrollX = window.scrollX || window.pageXOffset || 0;
  const scrollY = window.scrollY || window.pageYOffset || 0;
  const computedBodyStyle = window.getComputedStyle ? window.getComputedStyle(body) : null;
  const currentPaddingRight = parseFloat(computedBodyStyle?.paddingRight || '0') || 0;
  const scrollbarWidth = getScrollbarWidth();

  savedBodyState = {
    scrollX,
    scrollY,
    overflow: body.style.overflow,
    htmlOverflow: document.documentElement?.style.overflow || '',
    paddingRight: body.style.paddingRight
  };

  body.style.overflow = 'hidden';
  if (document.documentElement) {
    document.documentElement.style.overflow = 'hidden';
  }

  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
  }
}

export function unlockPopupScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    activePopupLocks = 0;
    savedBodyState = null;
    return;
  }

  if (!savedBodyState || activePopupLocks <= 0) {
    activePopupLocks = 0;
    return;
  }

  activePopupLocks -= 1;
  if (activePopupLocks > 0) {
    return;
  }

  const body = document.body;
  const previousState = savedBodyState;
  savedBodyState = null;

  if (!body) {
    return;
  }

  body.style.overflow = previousState.overflow;
  if (document.documentElement) {
    document.documentElement.style.overflow = previousState.htmlOverflow;
  }
  body.style.paddingRight = previousState.paddingRight;

  try {
    window.scrollTo({
      left: previousState.scrollX,
      top: previousState.scrollY,
      behavior: 'auto'
    });
  } catch (e) {
    window.scrollTo(previousState.scrollX, previousState.scrollY);
  }
}

export function resetPopupScrollLock() {
  while (activePopupLocks > 0) {
    unlockPopupScroll();
  }
}

export function patchPopupScrollLock(popupInstance) {
  if (
    !popupInstance ||
    popupInstance.__stepwisePopupScrollLockPatched ||
    typeof popupInstance.overrideOverflow !== 'function' ||
    typeof popupInstance.restoreOverflow !== 'function'
  ) {
    return popupInstance;
  }

  Object.defineProperty(popupInstance, '__stepwisePopupScrollLockPatched', {
    value: true,
    configurable: true,
    enumerable: false
  });

  // markerjs2 and cropro scroll the window to 0,0 in popup mode. Keep the viewport stable instead.
  popupInstance.overrideOverflow = function overrideOverflow() {
    lockPopupScroll();
  };

  popupInstance.restoreOverflow = function restoreOverflow() {
    unlockPopupScroll();
  };

  return popupInstance;
}

export function __resetPopupScrollLockForTests() {
  activePopupLocks = 0;
  savedBodyState = null;
}
